
import Vue from "vue";
import { AmplifyEventBus } from "aws-amplify-vue";

export default Vue.extend({
  name: "Logout",
  async created() {
    await Vue.prototype.$Amplify.Auth.signOut();
    AmplifyEventBus.$emit("authState", "signedOut");
  }
});
